import React from 'react';
import Intro from '../../components/Intro/Intro';
import NavBar from '../../components/NavBar/NavBar';

function About() {
  return (
    <>
      <NavBar />
      <Intro />
    </>
  );
}

export default About;
